module.exports = __webpack_public_path__ + "static/media/negotiation.30a94ac2.png";